import type { Editor } from '@tiptap/core';
import { useMarkHover } from './use-mark-hover.js';
import type { Suggestion } from '../components/SuggestionCard.js';

type UseSuggestionHoverReturn = {
  hoveredSuggestionId: string | null;
  hoveredSuggestion: Suggestion | null;
  hoveredSuggestionPosition: { top: number; left: number } | null;
  suggestionHoverCardContentRef: React.RefObject<HTMLDivElement>;
  closeSuggestionHover: () => void;
  onSuggestionHoverCardMouseEnter: () => void;
  onSuggestionHoverCardMouseLeave: () => void;
};

export const useSuggestionHover = (
  editor: Editor | null,
  suggestions: Suggestion[],
  isMobile: boolean
): UseSuggestionHoverReturn => {
  const {
    hoveredId,
    hoveredItem,
    hoveredPosition,
    hoverCardContentRef,
    closeHover,
    onHoverCardMouseEnter,
    onHoverCardMouseLeave,
  } = useMarkHover({
    editor,
    items: suggestions,
    markDataAttribute: 'data-suggestion-id',
    isMobile,
  });

  return {
    hoveredSuggestionId: hoveredId,
    hoveredSuggestion: hoveredItem,
    hoveredSuggestionPosition: hoveredPosition,
    suggestionHoverCardContentRef: hoverCardContentRef,
    closeSuggestionHover: closeHover,
    onSuggestionHoverCardMouseEnter: onHoverCardMouseEnter,
    onSuggestionHoverCardMouseLeave: onHoverCardMouseLeave,
  };
};
